<template>
    <div>
        <gmap-autocomplete name="address"
            class="form-control form-group__input input-md"
            placeholder=""
            required tabindex=2
            :options="addressOptions"
            v-model="address"
            ></gmap-autocomplete>
        <!-- <label class="bmd-label-static" for="address">{{ label }}</label> -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            address: null,
            name: _.get(this.config, 'name', 'address'),
            label: _.get(this.config, 'label', 'Street address'),
        }
    },

    props: ['initialData', 'config'],

    computed: {
        addressOptions() {
            return {
                componentRestrictions: {
                    country: 'nz'
                }
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/site/js/components/AddressAutocompleteComponent.vue